module.exports = __webpack_public_path__ + "img/safecharge-zcom.2ccb00c7.svg";